import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyHoneyIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./HoneyIcon-6e089140.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyHoneyIcon as P };
